var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCss3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.254 21.965C12.0804 22.0117 11.8974 22.0117 11.7239 21.9649L5.23719 20.2161C4.82979 20.1063 4.53419 19.757 4.49592 19.3402L3.00424 3.09261C2.95038 2.5059 3.41641 2 4.01076 2H19.9892C20.5836 2 21.0497 2.50597 20.9957 3.09272L19.5026 19.3373C19.4643 19.7541 19.1685 20.1034 18.761 20.2131L12.254 21.965ZM6.69941 10.1628L6.9035 12.3745H14.7967L14.5323 15.243L11.9921 15.9088L11.9901 15.9095L9.45367 15.2444L9.29151 13.4804H7.00526L7.32431 16.9532L11.9896 18.2108L12.0001 18.2081L16.6611 16.9532L17.2306 10.7567L17.2862 10.1628L17.6973 5.68625H6.28922L6.49624 7.89798H15.2014L14.9941 10.1628H6.69941Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss3);
export default __webpack_public_path__ + "static/media/css3.203f3452adea5f8495fb7d95a073011e.svg";
export { ForwardRef as ReactComponent };